<div class="alkusaldo-container">
  <h2 style="margin-top: 0">Alkusaldojen tuonti</h2>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding-bottom: 20px">
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Alkusaldometadata: <a [href]="tuontiEncodedUriObservable | async" target="_BLANK">{{ tuontiUriObservable | async }}</a>
      </div>
    </div>
  }

  <!-- Ei tilikausia -->
  @if (eiTilikausia) {
    <div class="virhe-viesti">
      Asiakkaalla ei ole tilikausia. Avaussaldoja voidaan ladata ainoastaan tilikausille.
      <button mat-raised-button color="primary" (click)="tallennaMappausJaSiirryTilikausiin()" style="margin-top: 8px">Muokkaa tilikausia</button>
    </div>
  }

  <!-- Tabit -->
  <mat-tab-group [(selectedIndex)]="aktiivinenTabiIndex" dynamicHeight>
    <mat-tab label="Tuonti">
      <div style="padding-top: 16px">
        <!-- Yläosa: tiedostot + tilikaudet -->
        <div style="display: flex; align-items: flex-start; gap: 24px; margin-bottom: 16px">
          <div style="flex: 1">
            @if (vaihe !== 'valinta') {
              @if (luetutTiedostonimetObservable | async; as tiedostonimet) {
                @if (tiedostonimet.length) {
                  <div style="margin-bottom: 8px">
                    Tiedostot: <strong>{{ tiedostonimet.join(', ') }}</strong>
                    @if (lahdejarjestelma().value() !== 'auto') {
                      <span class="lahdejarjestelma-badge">{{ lahdejarjestelma().value() }}</span>
                    }
                    @if (vaihe === 'mapping') {
                      <app-secondary-button (click)="palaaValintaan()" actionId="Muokkaa alkusaldotiedostoja"> Muokkaa tiedostoja </app-secondary-button>
                    }
                  </div>
                }
              }
            }

            <!-- Tiedostojen valinta -->
            @if (vaihe === 'valinta') {
              <div class="valinta-asetukset">
                <mat-form-field>
                  <mat-label>Lähdejärjestelmä</mat-label>
                  <mat-select [formField]="lahdejarjestelma">
                    <mat-option value="auto">Tunnistetaan automaattisesti</mat-option>
                    <mat-option value="netvisor">Netvisor (koneluettava pääkirja)</mat-option>
                    <mat-option value="procountor">Procountor (pääkirja CSV-muodossa)</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="valinta-osio">
                <div class="osio-otsikko">Valitut tiedostot</div>
                @if (valitutTiedostotSubject | async; as tiedostot) {
                  @if (tiedostot.length) {
                    <table class="tiedosto-taulukko">
                      <thead>
                        <tr>
                          <th>Tiedosto</th>
                          <th>Tilikaudet hallintokansiossa</th>
                          <th>Koko</th>
                          <th>Tila</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (tiedosto of tiedostot; track tiedosto.arkistoTiedostonAvain) {
                          <tr>
                            <td>
                              {{ tiedosto.tiedostonNimi }}
                              @if (kirjanpitajaOnDevaajaObservable | async) {
                                <a [href]="annaMetadataDebugLinkki(tiedosto)" target="_BLANK" style="margin-left: 8px">metadata</a>
                                <a [href]="annaBinaariDebugLinkki(tiedosto)" target="_BLANK" style="margin-left: 8px">binääri</a>
                              }
                            </td>
                            <td>{{ tiedosto.tilikausiAvaimet.length ? muotoileTilikaudet(tiedosto.tilikausiAvaimet) : 'Kaikki tilikaudet' }}</td>
                            <td>{{ muotoileKoko(tiedosto.koko) }}</td>
                            <td>
                              @switch (tiedosto.tila) {
                                @case ('hallintokansiossa') {
                                  <span class="tila-badge hallintokansiossa">Hallintokansiossa</span>
                                }
                                @case ('odottaa') {
                                  <span class="tila-badge odottaa">Odottaa lataamista</span>
                                }
                                @case ('ladataan') {
                                  <span class="tila-badge ladataan">Ladataan {{ tiedosto.latausprosentti | number: '1.0-0' }} %</span>
                                }
                                @case ('valmis') {
                                  <span class="tila-badge valmis">Valmis</span>
                                }
                                @case ('virhe') {
                                  <span class="tila-badge virhe">Virhe: {{ tiedosto.virheviesti }}</span>
                                }
                              }
                            </td>
                            <td style="text-align: right">
                              <app-icon-button matIcon="close" matTooltip="Poista listalta" [disabled]="lataaminenKesken" (click)="poistaTiedosto(tiedosto)" actionId="Poista alkusaldotiedosto listalta" [actionContext]="[tiedosto.tiedostonNimi]"></app-icon-button>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  } @else {
                    <p class="pvm-ohje" style="margin: 0">Ei valittuja tiedostoja. Lisää tiedostot alla tai valitse tiedosto hallintokansiosta toiminnolla "Lataa alkusaldot".</p>
                  }

                  @if (lataaminenKesken) {
                    <mat-progress-bar mode="determinate" [value]="kokonaisprosenttiObservable | async"></mat-progress-bar>
                  }
                }
              </div>

              <div class="valinta-osio">
                <div class="osio-otsikko">Lisää uusi tiedosto</div>
                <p class="pvm-ohje" style="margin: 0 0 8px">Valitse ensin tilikaudet, joihin tiedosto liitetään hallintokansiossa, ja lisää sitten yksi tiedosto kerrallaan.</p>
                <mat-form-field class="tilikausivalinta" floatLabel="always">
                  <mat-label>Tilikaudet hallintokansiossa</mat-label>
                  <mat-select [formField]="tilikausiAvaimet" multiple placeholder="Valitse tilikaudet">
                    @for (tk of tilikaudetObservable | async; track tk.avain) {
                      <mat-option [value]="tk.avain"> {{ tk.alkaa | lokaalipvm | async }} – {{ tk.loppuu | lokaalipvm | async }} </mat-option>
                    }
                  </mat-select>
                  <mat-error>Valitse vähintään yksi tilikausi</mat-error>
                </mat-form-field>
                <app-file-drop accept=".csv" [multiple]="false" dropZoneClassName="alkusaldo-drop-zone" contentClassName="alkusaldo-drop-sisalto" [disabled]="lataaminenKesken" (onFileDrop)="lisaaTiedosto($event)" (onFileOver)="tiedostoVedetaan(true)" (onFileLeave)="tiedostoVedetaan(false)">
                  <ng-template app-file-drop-content-tmp let-openFileSelector="openFileSelector">
                    <div class="alkusaldo-drop-alue" [class.aktiivinen]="vedetaanPaalle">
                      <div>Vedä pääkirjan CSV-tiedosto tähän tai</div>
                      <app-secondary-button (click)="openFileSelector()" [disabled]="lataaminenKesken || tilikausiAvaimet().invalid()" actionId="Valitse alkusaldotiedosto"> Valitse tiedosto </app-secondary-button>
                    </div>
                  </ng-template>
                </app-file-drop>

                @if (hylatytTiedostot.length) {
                  <div class="virhe-viesti" style="margin-top: 12px">
                    @for (hylatty of hylatytTiedostot; track hylatty) {
                      <div>{{ hylatty }}</div>
                    }
                  </div>
                }
              </div>

              <div class="toiminnot">
                <app-primary-button (click)="lueTiedostot()" [disabled]="!(valitutTiedostotSubject | async)?.length || lataaminenKesken" actionId="Lue alkusaldotiedostot" [actionContext]="[lahdejarjestelma().value()]"> Lue tiedostot </app-primary-button>
              </div>
            }

            @if (vaihe === 'mapping') {
              <div>
                <p>
                  Löydettiin <strong>{{ (lahdetilitObservable | async)?.length }}</strong> tiliä ja <strong>{{ (parsitutViennitObservable | async)?.length }}</strong> vientiä.
                </p>
                @if (vientienAikavaliObservable | async; as aikavali) {
                  <p>
                    Vientien aikaväli: <strong>{{ aikavali.alku }}</strong> – <strong>{{ aikavali.loppu }}</strong>
                  </p>
                }
              </div>
            }

            <!-- Päivämäärärajaus -->
            @if (vaihe !== 'valinta') {
              <div class="pvm-rajaus">
                <mat-form-field style="max-width: 150px">
                  <mat-label>Alkupäivämäärä</mat-label>
                  <input matInput [matDatepicker]="alkuPicker" [formField]="alkuPvm" />
                  <mat-datepicker-toggle matSuffix [for]="alkuPicker"></mat-datepicker-toggle>
                </mat-form-field>
                <mat-datepicker #alkuPicker></mat-datepicker>

                <mat-form-field style="max-width: 150px">
                  <mat-label>Loppupäivämäärä</mat-label>
                  <input matInput [matDatepicker]="loppuPicker" [formField]="loppuPvm" />
                  <mat-datepicker-toggle matSuffix [for]="loppuPicker"></mat-datepicker-toggle>
                </mat-form-field>
                <mat-datepicker #loppuPicker></mat-datepicker>

                <span class="pvm-ohje">Tyhjä = ei rajausta</span>
              </div>
            }
          </div>
          <div style="text-align: center">
            @if (tilikaudetObservable | async; as tilikaudet) {
              <div class="tilikaudet-info">
                <strong>Tilikaudet</strong>
                @for (tk of tilikaudet; track tk) {
                  <div class="tilikausi-rivi">
                    {{ tk.alkaa.day }}.{{ tk.alkaa.month }}.{{ tk.alkaa.year }} - {{ tk.loppuu.day }}.{{ tk.loppuu.month }}.{{ tk.loppuu.year }}
                    @if (tk.lukittu) {
                      <span class="tilikausi-merkinta"> (lukittu)</span>
                    }
                    @if (tk.tilikaudenVaihteenKirjauksetEstetty) {
                      <span class="tilikausi-merkinta"> (vaihdekirjaukset estetty)</span>
                    }
                  </div>
                }
                <div style="margin-top: 8px; display: flex; flex-direction: column; gap: 6px">
                  <button mat-button (click)="tallennaMappausJaSiirryTilikausiin()" style="font-size: 12px">Muokkaa tilikausia</button>
                </div>
              </div>
            }
            @if (asiakas) {
              <button mat-button color="warn" (click)="poistaKaikkiAlkusaldot()" style="font-size: 12px">Poista kaikki alkusaldot</button>
            }
          </div>
        </div>

        <!-- Aktiivisen rivin input + autocomplete — määritelty kerran, renderöidään aina vain klikatulle riville *ngTemplateOutletin kautta. -->
        <ng-template #aktiivinenTiliInputTemplate let-rivi>
          <mat-form-field class="kohdetili-select">
            <input matInput type="text" #aktiivinenTiliInput #tiliInput [matAutocomplete]="auto" [value]="hakuteksti" (input)="paivitaHaku(tiliInput.value)" placeholder="Etsi numerolla tai nimellä" autocomplete="off" />
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="valitseTili(rivi, $event.option.value)" (closed)="kasittelePanelinSulku(rivi)">
              @for (tili of suodatetutTilit; track tili.numero) {
                <mat-option [value]="tili.numero">{{ tili.numero }} - {{ tili.nimi }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </ng-template>

        <!-- Tilikarttamappaus -->
        @if (tilikarttaTilitObservable | async; as tilikartanTilit) {
          @if (vaihe === 'mapping') {
            <div>
              <div style="display: flex; align-items: center; gap: 12px">
                <p style="margin: 0">Valitse jokaiselle lähdetilille vastaava tili tilikarttastamme.</p>
                <button mat-button class="secondarybutton" (click)="piilotaMapatut = !piilotaMapatut">
                  {{ piilotaMapatut ? 'Näytä kaikki' : 'Piilota valmiit' }}
                </button>
              </div>
              <table class="mappaus-taulukko">
                <thead>
                  <tr>
                    <th>Lähdetili (numero)</th>
                    <th>Lähdetili (nimi)</th>
                    <th></th>
                    <th>Kohdetili</th>
                  </tr>
                </thead>
                <tbody>
                  @for (rivi of mappausRivitSubject | async; track rivi.lahdetili.numero) {
                    @if (!piilotaMapatut || !rivi.kohdetilinumero) {
                      <tr>
                        <td class="lahdetili-numero">{{ rivi.lahdetili.numero }}</td>
                        <td class="lahdetili-nimi">{{ rivi.lahdetili.nimi }}</td>
                        <td class="nuoli">→</td>
                        <td class="kohdetili-valinta">
                          @if (aktiivinenRivinNumero === rivi.lahdetili.numero) {
                            <ng-container *ngTemplateOutlet="aktiivinenTiliInputTemplate; context: { $implicit: rivi }"></ng-container>
                          } @else {
                            <div class="kohdetili-readonly" tabindex="0" (click)="aktivoiRivi(rivi)" (keydown.enter)="aktivoiRivi(rivi)" (focus)="aktivoiRivi(rivi)">
                              @if (rivi.kohdetilinumero) {
                                {{ annaNayttoteksti(rivi.kohdetilinumero) }}
                              } @else {
                                <span class="kohdetili-tyhja">Valitse tili</span>
                              }
                            </div>
                          }
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
              <div class="toiminnot">
                <app-secondary-button (click)="tallennaMappaus()" actionId="Tallenna alkusaldo-import-draft"> Tallenna ja jatka myöhemmin </app-secondary-button>
                <div style="flex: 1"></div>
                <div class="tuonnin-valinnat">
                  <mat-checkbox [formField]="luoAlkusaldokirjaukset"> Luo alkusaldokirjaukset (aineiston ensimmäisen tilikauden ensimmäiselle päivälle) </mat-checkbox>
                  <span class="pvm-ohje">Tuonti estää tilikauden vaihteen automaattikirjaukset kaikilta tuoduilta tilikausilta viimeisintä lukuun ottamatta. Eston voi muuttaa kirjanpitotiedoissa.</span>
                </div>
                <app-primary-button (click)="aloitaTuonti()" [disabled]="!kaikkiMapattu" actionId="Aloita alkusaldo-import"> Aloita tietojen lataaminen </app-primary-button>
              </div>
            </div>
          }
        }

        <!-- Käsittely -->
        @if (vaihe === 'processing') {
          <div>
            <h3>Käsitellään...</h3>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        }

        <!-- Valmis -->
        @if (vaihe === 'done') {
          <div>
            <div class="onnistuminen">
              <i class="icon ion-ios-checkmark-circle" style="font-size: 48px; color: #4caf50"></i>
              <p>{{ onnistumisviesti }}</p>
            </div>
          </div>
        }

        <!-- Virhe -->
        @if (virhe) {
          <div class="virhe-viesti">
            <p style="margin-top: 0">{{ virhe }}</p>
            @if (paallekkaisetTiedostot.length) {
              <ul class="paallekkaiset-tiedostot">
                @for (nimi of paallekkaisetTiedostot; track nimi) {
                  <li>{{ nimi }}</li>
                }
              </ul>
            }
            @if (vaihe === 'error') {
              <div style="display: flex; gap: 12px">
                <app-secondary-button (click)="palaaValintaan()" actionId="Virheestä takaisin alkusaldotiedostojen valintaan"> Muokkaa tiedostoja </app-secondary-button>
                @if (mappausRivitSubject.value.length) {
                  <app-secondary-button (click)="palaaKohdistukseen()" actionId="Virheestä takaisin alkusaldokohdistukseen"> Takaisin kohdistukseen </app-secondary-button>
                }
              </div>
            }
          </div>
        }
      </div>
    </mat-tab>

    <mat-tab label="Historia">
      <div style="padding-top: 16px">
        <div style="margin-bottom: 12px">
          <mat-form-field style="width: 200px">
            <mat-label>Suodata tyypillä</mat-label>
            <mat-select [value]="historiasuodatinSubject.value" (selectionChange)="historiasuodatinSubject.next($event.value)">
              <mat-option value="kaikki">Kaikki</mat-option>
              <mat-option value="tuonti">Tuonti</mat-option>
              <mat-option value="valitallennus">Välitallennus</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        @if (suodatettuHistoriaObservable | async; as historia) {
          <table class="historia-taulukko">
            <thead>
              <tr>
                <th>Aika</th>
                <th>Lähdejärjestelmä</th>
                <th>Tiedostot</th>
                <th>Lataaja</th>
                <th>Tyyppi</th>
              </tr>
            </thead>
            <tbody>
              @for (entry of historia; track entry) {
                <tr>
                  <td>{{ entry.tuotu?.toDate() | date: 'dd.MM.yyyy HH:mm' }}</td>
                  <td>{{ entry.lahdejarjestelma }}</td>
                  <td>{{ annaTiedostonimet(entry.tiedostot) }}</td>
                  <td>{{ entry.tuoja || '–' }}</td>
                  <td>
                    <span class="tyyppi-badge" [class.tuonti]="entry.tyyppi === 'tuonti'" [class.valitallennus]="entry.tyyppi === 'valitallennus'">
                      {{ entry.tyyppi === 'tuonti' ? 'Tuonti' : 'Välitallennus' }}
                    </span>
                  </td>
                </tr>
              }
              @if (historia.length === 0) {
                <tr>
                  <td colspan="5" style="text-align: center; padding: 20px; color: #999">Ei historiaa.</td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
